import { parseAxiosException } from '@/helpers/exceptionParser.js'
import { assoc, reduce } from 'ramda'

export default function moduleForFetchable({ name, url, toModel, apiClient }) {
  if (!name) console.error('No name given to moduleForFetchable')
  if (!url) console.error('No url given to moduleForFetchable')
  if (typeof url !== 'string' && typeof url !== 'function')
    console.error(
      'url given to moduleForFetchable must be string or function, but it is',
      typeof url,
    )
  if (!apiClient) console.error('No apiClient given to moduleForFetchable')

  const state = {
    [name]: toModel(),
    isFetching: false,
    wasFetched: false,
    shouldRefetch: true,
    fetchError: null,
    apiResponse: null,
  }
  const getters = {
    shouldFetch: state => !state.isFetching && (state.shouldRefetch || !state.wasFetched),
  }
  const capitalize = s => s.charAt(0).toUpperCase() + s.slice(1)
  const capitalizedName = capitalize(name)

  const mutations = {
    [`set${capitalizedName}`]: (state, payload) => (state[name] = payload),
    setIsFetching: (state, payload) => (state.isFetching = payload),
    setWasFetched: (state, payload) => (state.wasFetched = payload),
    setShouldRefetch: (state, payload) => (state.shouldRefetch = payload),
    setFetchError: (state, payload) => (state.fetchError = payload),
    setApiResponse: (state, payload) => (state.apiResponse = payload),
  }

  const actions = {
    [`maybeFetch${capitalizedName}`]: ({ getters, dispatch }, payload) => {
      if (getters.shouldFetch) return dispatch(`fetch${capitalizedName}`, payload)
    },
    [`fetch${capitalizedName}`]: async ({ commit }, payload) => {
      commit('setIsFetching', true)
      commit('setFetchError', null)
      try {
        const finalUrl = typeof url === 'function' ? url(payload) : url
        const result = await apiClient.get(finalUrl)
        commit('setApiResponse', result)
        commit(`set${capitalizedName}`, toModel(result.data))
      } catch (e) {
        console.error(e)
        commit('setFetchError', {
          rawError: e,
          parsedError: parseAxiosException(e),
        })
      }
      commit('setIsFetching', false)
      commit('setShouldRefetch', false)
    },
  }

  return { namespaced: true, state, getters, mutations, actions }
}
